import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { useT } from "../lib/i18n";

const PDF = {
  terms: "https://customer-assets-gfyr7b9c.emergentagent.net/job_joh-boxing-preview/artifacts/oz5ux43z_JOH_Boxing_Algemene_voorwaarden.pdf",
  privacy: "https://customer-assets-gfyr7b9c.emergentagent.net/job_joh-boxing-preview/artifacts/o4us3pcd_JOH_Boxing_Privacyverklaring.pdf",
};

function LegalPage({ variant }) {
  const { lang } = useT();
  const isTerms = variant === "terms";
  const titles = {
    terms: { nl: "Algemene voorwaarden", en: "Terms & conditions" },
    privacy: { nl: "Privacyverklaring", en: "Privacy statement" },
  };
  const src = isTerms ? PDF.terms : PDF.privacy;
  const title = titles[variant][lang];

  return (
    <main className="min-h-screen bg-[#F5F3F0] grain" data-testid={`legal-${variant}`}>
      <header className="px-6 md:px-10 py-5 line-b flex items-center justify-between bg-[#F5F3F0]/95 backdrop-blur-sm sticky top-0 z-40">
        <Link to="/" className="font-logo text-2xl md:text-3xl text-[#0A0A0A] accent-hover" data-testid={`legal-${variant}-logo`}>JOH.</Link>
        <div className="flex items-center gap-4">
          <a href={src} target="_blank" rel="noreferrer" className="chip text-[#4A4A4A] accent-hover inline-flex items-center gap-1" data-testid={`legal-${variant}-download`}>
            <Download size={12}/> {lang === "en" ? "Download PDF" : "Download PDF"}
          </a>
          <Link to="/" className="chip text-[#4A4A4A] accent-hover inline-flex items-center gap-1" data-testid={`legal-${variant}-back`}>
            <ArrowLeft size={14}/> {lang === "en" ? "Back to home" : "Terug naar home"}
          </Link>
        </div>
      </header>

      <section className="px-6 md:px-10 py-12 md:py-16 max-w-5xl">
        <div className="chip text-[#4A4A4A]">— JOH. Boxing / Legal</div>
        <h1 className="font-display uppercase text-5xl md:text-7xl leading-[0.86] mt-4 text-[#0A0A0A]" data-testid={`legal-${variant}-title`}>{title}</h1>
        <p className="mt-6 text-[#4A4A4A] max-w-2xl">
          {lang === "en"
            ? "The official document is embedded below. Use the download button in the header for offline access."
            : "Het volledige document staat hieronder. Gebruik de downloadknop bovenin voor offline gebruik."}
        </p>
      </section>

      <section className="px-6 md:px-10 pb-16">
        <object
          data={src}
          type="application/pdf"
          className="w-full border border-[#0A0A0A] bg-[#EAE7E2]"
          style={{ height: "80vh" }}
          data-testid={`legal-${variant}-pdf`}
        >
          <div className="p-10 text-center">
            <p className="text-[#0A0A0A] mb-4">{lang === "en" ? "Your browser can't display this PDF inline." : "Je browser kan de PDF niet inline tonen."}</p>
            <a href={src} target="_blank" rel="noreferrer" className="btn inline-flex" data-testid={`legal-${variant}-fallback`}>
              <Download size={14}/> {lang === "en" ? "Open PDF" : "PDF openen"}
            </a>
          </div>
        </object>
      </section>
    </main>
  );
}

export function Terms() { return <LegalPage variant="terms"/>; }
export function Privacy() { return <LegalPage variant="privacy"/>; }
